import React from "react";

export function PortalAuthLayout({ children }) {
  return (
    <main>
      <section className="relative w-full h-full flex items-center justify-items-center min-h-screen max-h-screen max-w-screen">
        {children}
      </section>
    </main>
  );
}
